import Input from "../components/Input";

export default function BillingAddonTickets({
	qty,
	thu,
	fri,
	sat,
	sun,
	handleUpdate,
	errors,
}) {
	return (
		<table
			className="approved"
			style={{ marginTop: "25px", marginBottom: "5px" }}
		>
			<thead>
				<tr>
					<th colSpan="4">
						{`Select the number of add-on hospitality tickets for each day (${qty}
						total)`}
					</th>
				</tr>
				<tr>
					<td className="center" style={{ width: "25%" }}>
						Thu
					</td>
					<td className="center" style={{ width: "25%" }}>
						Fri
					</td>
					<td className="center" style={{ width: "25%" }}>
						Sat
					</td>
					<td className="center" style={{ width: "25%" }}>
						Sun
					</td>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td style={{ padding: "15px" }}>
						<Input
							type="number"
							name="thu"
							label=""
							reqd={true}
							value={thu}
							autocomplete="off"
							update={handleUpdate}
							errors={errors}
						/>
					</td>
					<td style={{ padding: "15px" }}>
						<Input
							type="number"
							name="fri"
							label=""
							reqd={true}
							value={fri}
							autocomplete="off"
							update={handleUpdate}
							errors={errors}
						/>
					</td>
					<td style={{ padding: "15px" }}>
						<Input
							type="number"
							name="sat"
							label=""
							reqd={true}
							value={sat}
							autocomplete="off"
							update={handleUpdate}
							errors={errors}
						/>
					</td>
					<td style={{ padding: "15px" }}>
						<Input
							type="number"
							name="sun"
							label=""
							reqd={true}
							value={sun}
							autocomplete="off"
							update={handleUpdate}
							errors={errors}
						/>
					</td>
				</tr>
			</tbody>
		</table>
	);
}
